import { createEvent } from 'effector';
import { type PayinTicketFilters } from '~/entities/payin';

export const setTicketsFilter = createEvent<PayinTicketFilters>();
